import * as ActionTypes from '../../actions/types'
import { mapUser } from "../../types/user/map";
import { fromJS } from "immutable";
import { ROUTE_PAGE_LOGIN } from "../../routers/routes";
import { getRouteUrl } from "../../helpers/getRouteUrl";

const INITIAL_STATE = {
	token: null,
	language: 'en',
	decimalSeparator: ',',
	thousandSeparator: '.',
	dateFormat: 'DD/MM/YYYY',
	timeFormat: 'HH:mm',
	loading: false,
	isLoggedIn: false,
	message: null,
	tokenExpirationDateTime: null,
	data: null,
	changeFormatsWithLang: true,
}

function setUserLanguage(state, action) {
	return state
	.set('language', action.payload)
	.set('decimalSeparator', state.get('changeFormatsWithLang') ? action.payload === 'el' ? ',' : '.' : state.get('decimalSeparator'))
	.set('thousandSeparator', state.get('changeFormatsWithLang') ? action.payload === 'el' ? '.' : ',' : state.get('thousandSeparator'))
	.set('dateFormat', state.get('changeFormatsWithLang') ? action.payload === 'el' ? 'DD/MM/YYYY' : 'MM/DD/YYYY' : state.get('dateFormat'))
	.set('timeFormat', state.get('changeFormatsWithLang') ? action.payload === 'el' ? 'HH:mm' : 'HH:mm' : state.get('timeFormat'))
}

function setUserMessage(state, action) {
	const message = action.payload
	return state
	.set('message', fromJS(message ? {
		text: message?.text, variant: message?.variant
	} : null))
}

function checkAPIConnectivity(state) {
	return state
	.set('loading', false)
	.set('message', null)
}

function checkAPIConnectivitySucceeded(state) {
	return state
	.set('loading', false)
	.set('message', null)
}

function checkAPIConnectivityFailed(state) {
	return state
	.set('loading', false)
	.set('message', fromJS({
		text: 'Access failed!', variant: 'error'
	}))
}

function userLogin(state) {
	return state
	.set('message', null)
	.set('token', null)
	.set('loading', true)
	.set('selectedStore', null)
	.set('isLoggedIn', false)
}

function userLoginSucceeded(state, action) {
	const { access_token, expires_in, langcode, loginname, username } = action.payload
	const tokenExpirationDateTime = new Date()
	tokenExpirationDateTime.setSeconds(tokenExpirationDateTime.getSeconds() + expires_in)
	const user = mapUser({
		locale: langcode,
		LoginName: loginname,
		username: username
	})
	return state
	.set('message', null)
	.set('loading', false)
	.set('token', access_token)
	.set('tokenExpirationDateTime', tokenExpirationDateTime)
	.set('isLoggedIn', true)
	.set('data', fromJS(user))
	// .set('language', langcode?.toLowerCase())
}

function userLoginFailed(state, action) {
	const { message } = action.payload
	return state
	.set('message', fromJS({
		text: message, variant: 'error'
	}))
	.set('token', null)
	.set('loading', false)
	.set('isLoggedIn', false)
}

function userLogoutSucceeded(state, action) {
	window.location.href = getRouteUrl(ROUTE_PAGE_LOGIN)
	return state
	.set('message', null)
	.set('token', null)
	.set('loading', false)
	.set('isLoggedIn', false)
}

const currentUser = {
	initialState: INITIAL_STATE,
	handlers: {
		[ActionTypes.CHECK_API_CONNECTIVITY]: checkAPIConnectivity,
		[ActionTypes.CHECK_API_CONNECTIVITY_SUCCEEDED]: checkAPIConnectivitySucceeded,
		[ActionTypes.CHECK_API_CONNECTIVITY_FAILED]: checkAPIConnectivityFailed,
		
		[ActionTypes.USER_LOGIN]: userLogin,
		[ActionTypes.USER_LOGIN_SUCCEEDED]: userLoginSucceeded,
		[ActionTypes.USER_LOGIN_FAILED]: userLoginFailed,
		[ActionTypes.USER_LOGOUT_SUCCEEDED]: userLogoutSucceeded,
		
		[ActionTypes.SET_USER_MESSAGE]: setUserMessage,
		[ActionTypes.SET_USER_LANGUAGE]: setUserLanguage,
	}
}

export default currentUser